import { Text } from '$components'
import { ReactNode } from 'react'

export type SidebarGroupProps = {
  title: string,
  children: ReactNode
}

export function SidebarGroup({ title, children }: SidebarGroupProps) {
  return (
    <div className="mb-6">
      <Text
        as="h3"
        type="xs"
        className="uppercase text-gray-500 px-3 mb-2"
      >
        { title }
      </Text>

      <div className="flex flex-col gap-1">
        { children }
      </div>
    </div>
  )
}
